import { FormattedMessage } from 'react-intl';

const brValues = { br: <br /> };

/**
 * Shown when the back office reported the deal as not integrated yet: the deal is done, but its
 * trade id is not available. Restores the message the legacy fx app displayed in that situation.
 */
export const GrowlIntegrationDelay = () => (
  <div className="alert alert-outline-warning p-2 my-2" data-e2e="growl-integration-delay">
    <FormattedMessage id="growl.alert.integrationDelay" values={brValues} />
  </div>
);
